import React, { useContext } from "react";
import { Dimensions, StyleSheet, View, Text } from "react-native";
import palette from "~/styles/palette";
import Card from "../../../components/Card";
import Heading from "../../../components/Heading/index";
import Paragraph from "../../../components/Paragraph/index";
import Logo from "../../../components/Logo/index";
import SolidButton from "../../../components/Buttons/SolidButton/index";
import UserContext from "../../../contexts/UserContext";

export default function WelcomeStep({ nextStep }) {
  const { user } = useContext(UserContext);
  return (
    <View style={{ height:400, padding: 24, flexDirection: "column", justifyContent: 'space-between' }}>
      
      <View style={{ alignItems:'center'}}>
        <Logo height={70} width={70} />
      </View>
      
      <View>
        <Heading center mb={0} mt={10}>
          Welcome {user?.first_name}!
        </Heading>
      </View>

      <View  style={{ justifyContent: "center", flex:1 }}>
        <Paragraph center mb={30}>
          To get you started engaging customers, we need to verify a few things
          and setup an Engage number for your account.
        </Paragraph>
      </View>
      
      <View>
        <SolidButton
          label="Verify your phone number"
          color={palette.primary}
          onPress={nextStep}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  welcome_screen__container: {
    backgroundColor: palette.light_grey,
  },
});
